import i18n from "@/i18n";
import { DepositForecastItemModel } from "../../models/forecast/depositForecastItemModel";
import IContractService from "../../services/contracts/IContractService";
import { container } from "@/inversify.config";
import { DiTokens } from "../../services/diTokens";
import { Prop } from "vue-property-decorator";
import { ContractsStore } from "../../store/modules/contracts";
import { getModule } from "vuex-module-decorators";
import IAlertService from "../../services/alert/IAlertService";
import { ContractModel } from "../../models/contracts/contractModel";
import Vue from "vue";

/**
 *  Класс для компоненты графика вклада.
 */
export class ForecastModalVue extends Vue {
  @Prop() id!: number;

  /**
 * Хранилище счетов
 * @returns {ContractsStore}
 */
  get contractsStore(): ContractsStore {
    return getModule(ContractsStore, this.$store);
  }

  /**
 * Выбранный счет
 * @returns {ContractModel} - модель счета
 */
  get contract(): ContractModel {
    return this.contractsStore.contracts.getContract(this.id);
  }

  /**
 * Сервис счетов
 * @returns {IContractService}
 */
  get contractService(): IContractService {
    return container.get<IContractService>(DiTokens.ContractService);
  }

  /**
 * Сервис уведомлений
 * @returns {IAlertService}
 */
  get alertService(): IAlertService {
    return container.get<IAlertService>(DiTokens.AlertService);
  }

  /**
 * Признак загрузки
 * @returns {boolean} - Признак загрузки
 */
  get loading(): boolean {
    return this.contractsStore.forecastLoading;
  }

  /** загрузка файла */
  fileLoading: boolean = false;

  /**
 * Признак капитала
 * @returns {boolean} - Признак капитала
 */
  get isCapitalization(): boolean {
    return this.contract.DepositForeCast.some(
      (item: DepositForecastItemModel) => item.Capitalization === true
    );
  }

  /** Открытие файла */
  async openFile() {
    this.fileLoading = true;
    const fileUrl: string = await this.contractService.getFile(
      this.contract.Data.Id,
      "ForecastStatementToPdf"
    );
    if (fileUrl.length > 0) {
      window.open(fileUrl, "_blank");
    } else {
      this.alertService.error(
        i18n.t("main.operations.errors.loadStatementError").toString()
      );
    }
    this.fileLoading = false;
  }

  /**
 * Заголовки таблицы
 * @returns {Array<string>} - массив заголовков
 */
  get tableHeaders(): Array<string> {
    if (this.isCapitalization) {
      return [
        i18n.t("main.contracts.forecastTable.forecastTableDate").toString(),
        i18n
          .t("main.contracts.forecastTable.forecastTablePercents", {
            cur: this.contract.Currency
          })
          .toString(),
        i18n
          .t("main.contracts.forecastTable.forecastTableRest", {
            cur: this.contract.Currency
          })
          .toString(),
        i18n
          .t("main.contracts.forecastTable.forecastTableIncome", {
            cur: this.contract.Currency
          })
          .toString()
      ];
    }
    return [
      i18n.t("main.contracts.forecastTable.forecastTableDate").toString(),
      i18n
        .t("main.contracts.forecastTable.forecastTablePercents", {
          cur: this.contract.Currency
        })
        .toString(),
      i18n
        .t("main.contracts.forecastTable.forecastTableIncome", {
          cur: this.contract.Currency
        })
        .toString()
    ];
  }

  /**
 * Ключи таблицы
 * @returns {Array<any>} - массив ключей
 */
  get tableKeys(): Array<any> {
    if (this.isCapitalization) {
      return ["Date", "Percents", "Rest", "InCome"];
    }
    return ["Date", "Percents", "InCome"];
  }
}
